// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"c6b37daf-168":"9533b9679b42c74eae47","c6b37daf-204":"cdf9364cc9e9e68a9a51"}[chunkId] + ".js";
};